/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Section_WritingInputs */

const en_marketing_section_writing = /** @type {(inputs: Marketing_Section_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing`)
};

const es_marketing_section_writing = /** @type {(inputs: Marketing_Section_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos`)
};

const fr_marketing_section_writing = /** @type {(inputs: Marketing_Section_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écrits`)
};

/**
* | output |
* | --- |
* | "Writing" |
*
* @param {Marketing_Section_WritingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_section_writing = /** @type {((inputs?: Marketing_Section_WritingInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Section_WritingInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_section_writing(inputs)
	if (locale === "es") return es_marketing_section_writing(inputs)
	return fr_marketing_section_writing(inputs)
});